var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlipay({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#06b4fd",
    d: "M6.75 16.888c-.414.3-.711.735-.84 1.23a2.58 2.58 0 0 0 .66 2.34 4.5 4.5 0 0 0 2.685 1.14 7.24 7.24 0 0 0 4.32-1.485 9.1 9.1 0 0 0 2.05-2.04 12.8 12.8 0 0 0-6.225-1.8 6.06 6.06 0 0 0-2.65.615m22.048 3.975a14.991 14.991 0 1 0-1.65 2.925c-2.58-1.275-6.825-3.39-9.45-4.665a11.54 11.54 0 0 1-5.174 3.465 7.4 7.4 0 0 1-3.72.285 5 5 0 0 1-2.654-1.395 5 5 0 0 1-.795-1.11.2.2 0 0 1 .03.09q-.15-.27-.225-.57a3 3 0 0 1-.105-.525 1.6 1.6 0 0 1 0-.375q-.022-.355.045-.705a3.5 3.5 0 0 1 1.035-1.92 5.96 5.96 0 0 1 4.365-1.47 23.3 23.3 0 0 1 6.21 1.425 21 21 0 0 0 1.23-3.555h-9v-.975h4.625V9.84H7.98v-.99h5.58V6.9c0-.27.06-.48.48-.48h2.19v2.43h6.074v.975H16.23v1.95h4.86a19.4 19.4 0 0 1-2.01 5.4c3.373 1.2 8.143 3.059 9.718 3.689"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v30H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlipay);
export default __webpack_public_path__ + "static/media/Alipay.75a2840aa0d7fec501a574274292cd3f.svg";
export { ForwardRef as ReactComponent };